export const inDevelopMode = process.env.REACT_APP_NODE_ENV === "development";
export const inProductionMode = process.env.REACT_APP_NODE_ENV === "production";
export const inLocalMode =
  process.env.REACT_APP_NODE_ENV !== "production" &&
  process.env.REACT_APP_NODE_ENV !== "development";


export const API_URL = process.env.REACT_APP_API_URL;

const currentHost =
  typeof window !== "undefined" ? window.location.hostname.toLowerCase() : "";

let apiHost = "";
try {
  apiHost = API_URL ? new URL(API_URL).hostname.toLowerCase() : "";
} catch {
  apiHost = "";
}

const matchesDomain = (value, domain) =>
  value === domain || value.endsWith(`.${domain}`);

export const isLive =
  matchesDomain(currentHost, "zd.propone.pk") ||
  matchesDomain(apiHost, "zd.propone.pk");

export const isTraining =
  matchesDomain(currentHost, "training.propone.pk") ||
  matchesDomain(apiHost, "training.propone.pk");

